import type { WaveCoverKeys, WaveRecord } from "@vida/wave-core";
import { WaveCoverBanner } from "./WaveCoverBanner";

type Props = {
  wave: WaveRecord;
  variant?: "card" | "list";
  onCoverKeyChange?: (waveId: string, keys: WaveCoverKeys) => void;
};

export function WaveCoverThumbnail({ wave, variant = "card", onCoverKeyChange }: Props) {
  return (
    <WaveCoverBanner wave={wave} variant={variant} onCoverKeyChange={onCoverKeyChange} />
  );
}
